import React from 'react';

import { TreeNode } from 'hooks/device-management/useTree/types';

// components
import { OwnerName } from 'components/Labels';

interface Props {
  node: TreeNode;
}

export const OwnerCell = ({ node }: Props): JSX.Element => {
  return (
    node.type === 'zone'
      ? <OwnerName ownerId={ node.zone.owner_id }/>
      : <></>
  );
};
